import request from '@/utils/request'

// 查询诚聘英才列表
export function listJob(query) {
  return request({
    url: '/ws/job/list',
    method: 'get',
    params: query
  })
}

